<script setup>
import { onMounted, useTemplateRef, ref } from "vue";
import { useScrollStore } from "@/stores/storeScroll";
import { useSettingsStore } from "@/stores/storeSettings";

const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();

const header = useTemplateRef("header");
const mobileMenuActive = ref(false);

defineProps({
	pageLoaded: {
		type: Boolean,
	},
});

const addClassToRoot = () => {
  const appElement = document.getElementById('app')
  if (appElement) {
    appElement.classList.toggle('noscroll')
  }
}

const mobileMenu = () => {
    mobileMenuActive.value = !mobileMenuActive.value;
    addClassToRoot();
}  

onMounted(() => {
	storeScroll.header = header.value;
});
</script>
<template>
	<div @click="mobileMenu" id="overlay" :class="{ active: mobileMenuActive }"></div>
	<div @click="mobileMenu" :class="['mobile-menu', { active: mobileMenuActive }]">
		<div class="header__links">
			<RouterLink to="/services" class="header-link">Забронировать</RouterLink>
			<nav class="nav">
				<a :href="`tel:${storeSettings.contactsPhone}`" target="_blank" class="nav__link">
					<svg width="40" height="40"><use href="#phone"></use></svg>
				</a>
				<a :href="storeSettings.contactsTelegram" target="_blank" class="nav__link">
					<svg width="40" height="40"><use href="#telegram"></use></svg>
				</a>
				<a :href="storeSettings.contactsWhatsapp" target="_blank" class="nav__link">
					<svg width="40" height="40"><use href="#wa"></use></svg>
				</a>
			</nav>
		</div>
		<div class="mobile-menu__contacts">
			<div class="footer__container" >
				<div class="footer__top">
					<div class="footer__info">
						<ul class="footer__list">
							<li>Контакты</li>
							<li>
								<a :href="`tel:${storeSettings.contactsPhone}`">{{ storeSettings.contactsPhone }}</a>
							</li>
							<li>
								<a :href="`mailto:${storeSettings.contactsEmail}`">{{ storeSettings.contactsEmail }}</a>
							</li>
						</ul>
						<ul class="footer__list">
							<li>Режим работы</li>
							<li v-for="(item, index) in storeSettings.contactsWorkTime" :key="index">{{ item }}</li>
						</ul>
						<ul class="footer__list">
							<li>Адрес</li>
							<li>{{ storeSettings.contactsAddress }}</li>
						</ul>
					</div>
				</div>
				<div class="footer__bottom">
					<span>The Rink Fitness © Все права защищены</span>
					<div class="footer__bottom-links">
						<div class="footer__links">
							<a :href="storeSettings.settings.documents?.offer" target="_blank">Оферта</a>
							<a :href="storeSettings.settings.documents?.rules" target="_blank">Правила клуба</a>
							<a :href="storeSettings.settings.documents?.privacy_policy" target="_blank">Обработка персональных данных</a>
						</div>
						<a href="https://lucky-site.com/" target="_blank" rel="noopener noreferrer" class="footer__logo-web">
							<span>Разработка сайта</span>
							<img class="" width="78" height="38" src="@/assets/img/icons/logo_lucky.svg" alt="изображение логотипа" />
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<header :class="['header', { animated: !pageLoaded }, { 'header--fixed': storeScroll.headerFixed }, { 'header--base-background': storeScroll.headerFixed && mobileMenuActive }]" ref="header" data-animation-top>
		<div class="container">
			<div class="header__container">
				<a href="#wrapper" class="logo --header"><img loading="lazy" width="200" height="64" src="@/assets/img/icons/logo.svg" alt="логотип" /></a>
				<div class="header__links">
					<nav class="nav">
						<a :href="`tel:${storeSettings.contactsPhone}`" target="_blank" class="nav__link">
							<svg width="40" height="40"><use href="#phone"></use></svg>
						</a>
						<a :href="storeSettings.contactsTelegram" target="_blank" class="nav__link">
							<svg width="40" height="40"><use href="#telegram"></use></svg>
						</a>
						<a :href="storeSettings.contactsWhatsapp" target="_blank" class="nav__link">
							<svg width="40" height="40"><use href="#wa"></use></svg>
						</a>
					</nav>
				</div>
				<div @click="mobileMenu" :class="['nav-icon', { active: mobileMenuActive }]"><span></span></div>
			</div>
		</div>
	</header>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/blocks/nav-icon";
@use "@/assets/scss/blocks/mobile-menu";
</style>
@/stores/storeSettings @/stores/storeScroll
